export const settingsTabs = [
  { title: 'ارزها', link: '/settings' },
  { title: 'تخفیف‌ها', link: '/settings/discounts' },
  { title: 'کارمزدها', link: '/settings/commissions' },
  { title: 'اعتبار پیشنهادها', link: '/settings/offers-validity' },
  { title: 'وبلاگ', link: '/settings/blog' },
  { title: 'دسته‌بندی خدمات', link: '/settings/service-categories' },
  { title: 'مدیریت درگاه های پرداخت', link: '/settings/payments' },
  { title: 'روش‌های پرداخت', link: '/settings/payment-methods' },
  { title: 'ارائه‌دهنده‌های سرویس', link: '/settings/service-providers' },
]
